import { Component, ViewContainerRef } from '@angular/core';
import { ReportService } from '../../services/report.service';
import { BlockUiService } from '../../services/blockui.service';
import { CaseService } from '../../services/case.service';

@Component({
	selector: 'app-report-admin',
	templateUrl: './report-admin.component.html'
})
export class ReportAdminComponent {

	dateFrom: Date = null;
	dateTo: Date = null;
	error = '';

	constructor(
		private reportService: ReportService,
		private blockUi: BlockUiService,
		private vcRef: ViewContainerRef,
		private caseService: CaseService
	) { }

	exportNewCases() {
		this.error = '';
		if (!this.dateFrom || !this.dateTo) {
			this.error = 'Моля, изберете начална и крайна дата.';
			return;
		}

		const from = this.caseService.toBackendIsoDate(this.dateFrom);
		const to = this.caseService.toBackendIsoDate(this.dateTo);

		if (!from || !to) {
			this.error = 'Невалидна дата.';
			return;
		}

		this.blockUi.start(this.vcRef);
		this.reportService.executeNewCasesReport(from, to).subscribe(
			resp => {
				this.blockUi.stop();
				const blob = resp.body;
				const url = window.URL.createObjectURL(blob);
				const a = document.createElement('a');
				a.href = url;
				a.download = 'novi_dela_' + from + '_' + to + '.xlsx';
				a.click();
				window.URL.revokeObjectURL(url);
			},
			err => {
				this.blockUi.stop();
				this.error = 'Грешка при генериране на справката.';
			}
		);
	}
}
